import {StepProps} from "../../steps/components/DecisionComponent/Decision.component";
import {withNamespaces} from "react-i18next";
import React, {useContext} from "react";
import {CancellationProcessContext} from "./CancellationProcess.component";
import InputGroup from "../../forms/components/InputGroup/InputGroup";
import MoneyHelper from "../../../services/MoneyHelper";
import CancellationOfferService from "../services/CancellationOfferService";
import {AuthContext} from "../../member/components/AuthContext";

const ReduceRateComponent = (props) => {
  const {t} = props;
  const reduceRateData = props.data.reduce_rate || {};
  const {cancelDetails} = useContext(CancellationProcessContext);
  const {member} = useContext(AuthContext);

  const changeData = (key, value) => {
    props.setData({reduce_rate: {...reduceRateData, [key]: value}});
  }

  const getDiscountedPrice = () => {
    return CancellationOfferService.getDiscountedPrice(member.plan_info.nextDue, cancelDetails.reduce_rate.discount);
  }

  const getDiscountPeriod = () => {
    const paidUntil = new Date(member.plan_info.nextDueDate);
    const discountTo = CancellationOfferService.getDiscountEnd(paidUntil, cancelDetails.reduce_rate.numberOfMonths);
    return `${paidUntil.toLocaleDateString()} - ${discountTo.toLocaleDateString()}`;
  };

  const getTotalSavings = () => {
    const discountedPrice = getDiscountedPrice();
    const currentPrice = member.plan_info.nextDue;

    return CancellationOfferService.getSavings(currentPrice, discountedPrice, cancelDetails.reduce_rate.numberOfMonths);
  }

  return (
    <div className="cancellation-offer-component">
      <p className='light'>{t('member_cancellation_reduce_rate_description')}</p>

      <div className='cancellation-offer-description'>
        <div className='cancellation-offer-description-image'>
          <img src="/images/cancellation/reduce-rate.png" alt="Reduce Rate offer logo" />
        </div>
        <div className='cancellation-offer-description-text'>
          <h3 className="mb-8">{t('member_cancellation_reduce_rate_header')}</h3>

          <div className="cancellation-offer-info-block">
            {[
              {text: t('member_cancellation_reduce_rate_current_price'), value: t('member_cancellation_reduce_rate_month_price', {price: MoneyHelper.toPrice(member.plan_info.nextDue)})},
              {
                text: t('member_cancellation_reduce_rate_new_rate'),
                value: t('member_cancellation_reduce_rate_month_price', {price: MoneyHelper.toPrice(getDiscountedPrice())}),
                isRedValue: true
              },
              {text: t('member_cancellation_reduce_rate_effective_dates'), value: getDiscountPeriod()},
              {text: t('member_cancellation_reduce_rate_total_savings'), value: MoneyHelper.toPrice(getTotalSavings())},
            ].map((item, index) => (
              <div key={index}>
                <div className='cancellation-offer-label'>{item.text}</div>
                <div className={`cancellation-offer-value ${item.isRedValue ? 'red-text' : ''}`}>{item.value}</div>
              </div>
            ))}

            <p className='canellation-offer-disclaimer'>{t('member_cancellation_reduce_rate_disclaimer')}</p>
          </div>


          <div className="form-group terms">
            <div className="checkbox">
              <input
                id={`accept_terms`}
                name={`accept_terms`}
                type="checkbox"
                checked={reduceRateData.terms_accepted}
                onChange={() => {
                  changeData('terms_accepted', !reduceRateData.terms_accepted)
                }}/>
              <label htmlFor={`accept_terms`}>
                <div dangerouslySetInnerHTML={{
                  __html: props.t(`membership_cancellation_cancellation_offer_terms`)
                }}/>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ReduceRateComponent.propTypes = StepProps;

export default withNamespaces()(ReduceRateComponent);